//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import ArticleCard from "@/pages/catalog/components/ArticleCard.vue"

export default BaseCmsBlock.extend({
  name: "TextCardBlock",
  data() {
    // console.log(this,)
    return {}
  },
  components: {
    ArticleCard
  }
})
